import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";

import PlatformOverviewDashboard from "pages/platform-overview-dashboard";
import UsageAnalyticsPerformanceMonitoring from "pages/usage-analytics-performance-monitoring";
import RevenueIntelligenceDashboard from "pages/revenue-intelligence-dashboard";
import SupportOperationsIntelligence from "pages/support-operations-intelligence";
import TenantManagementAnalytics from "pages/tenant-management-analytics";
import Login from "pages/auth/Login";
import NotFound from "pages/NotFound";
import PublicRoute from "components/protected/PublicRoute";
import PrivateRoute from "components/protected/PrivateRoute";


const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>

          {/* Default */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Public */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />

          {/* Protected */}
          <Route
            path="/platform-overview-dashboard"
            element={
              <PrivateRoute>
                <PlatformOverviewDashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/usage-analytics-performance-monitoring"
            element={
              <PrivateRoute>
                <UsageAnalyticsPerformanceMonitoring />
              </PrivateRoute>
            }
          />

          <Route
            path="/revenue-intelligence-dashboard"
            element={
              <PrivateRoute>
                <RevenueIntelligenceDashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/support-operations-intelligence"
            element={
              <PrivateRoute>
                <SupportOperationsIntelligence />
              </PrivateRoute>
            }
          />

          <Route
            path="/tenant-management-analytics"
            element={
              <PrivateRoute>
                <TenantManagementAnalytics />
              </PrivateRoute>
            }
          />

          <Route path="*" element={<NotFound />} />

        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
